export const ANALYTICS_COLORS = ['#32CC66', '#CC3398', '#8C33CC', '#324DCB', '#31BFCC'];
